import { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

export function DropdownFilter({
  options,
  value,
  onChange,
  placeholder = "Select",
}) {
  const [isOpen, setIsOpen] = useState(false);
  const selected = options.find((opt) => opt.value === value) || options[0];

  const handleSelect = (option) => {
    onChange(option.value);
    setIsOpen(false);
  };

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between py-2.5 px-4 bg-white border border-gray-200 rounded-xl text-sm text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-primary"
      >
        {selected?.label || placeholder}
        {isOpen ? (
          <ChevronUp size={16} className="ml-2 text-gray-500" />
        ) : (
          <ChevronDown size={16} className="ml-2 text-gray-500" />
        )}
      </button>

      {isOpen && (
        <div className="absolute right-0 z-10 mt-2 w-48 bg-white rounded-lg shadow border border-gray-100">
          <ul className="py-2 text-sm text-gray-700">
            {options.map((opt) => (
              <li key={opt.value}>
                <button
                  className="w-full text-left block px-4 py-2 hover:bg-primary/10"
                  onClick={() => handleSelect(opt)}
                >
                  {opt.label}
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}

/* 
import { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

export function DropdownFilter({
  options,
  value,
  onChange,
  placeholder = "Select",
  className = "", 
}) {
  const [isOpen, setIsOpen] = useState(false);
  const selected = options.find((opt) => opt.value === value) || options[0];

  const handleSelect = (option) => {
    onChange(option.value);
    setIsOpen(false);
  };

  return (
    <div className="relative w-full">
      {" "}
      
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`w-full flex items-center justify-between py-2.5 px-4 bg-white border border-gray-200 rounded-lg text-sm text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-primary ${className}`}
      >
        {selected?.label || placeholder}
        {isOpen ? (
          <ChevronUp size={16} className="ml-2 text-gray-500" />
        ) : (
          <ChevronDown size={16} className="ml-2 text-gray-500" />
        )}
      </button>
      {isOpen && (
        <div className="absolute right-0 mt-2 w-full bg-white rounded-lg shadow border border-gray-100">
          <ul className="py-2 text-sm text-gray-700">
            {options.map((opt) => (
              <li key={opt.value}>
                <button
                  className="w-full text-left block px-4 py-2 hover:bg-primary/10"
                  onClick={() => handleSelect(opt)}
                >
                  {opt.label}
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}

*/
